module.exports = __webpack_public_path__ + "static/media/handbags_open_graph.f9c5e7ff.jpg";